export default "__VITE_ASSET__CTdXA_SR__"